import axios, { API_URL } from './BaseService';

export async function getProfitVault() {
    const response = await axios.get(`${API_URL}/profit-vault`);
    return response.data;
}
